import { render, staticRenderFns } from "./SubmissionTabsContainer.vue?vue&type=template&id=0683c3f6&scoped=true&"
import script from "./SubmissionTabsContainer.vue?vue&type=script&lang=js&"
export * from "./SubmissionTabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionTabsContainer.vue?vue&type=style&index=0&id=0683c3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683c3f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0683c3f6')) {
      api.createRecord('0683c3f6', component.options)
    } else {
      api.reload('0683c3f6', component.options)
    }
    module.hot.accept("./SubmissionTabsContainer.vue?vue&type=template&id=0683c3f6&scoped=true&", function () {
      api.rerender('0683c3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/SubmissionTabsContainer.vue"
export default component.exports